import React from "react";

import PaymentInfo from "../../components/VendorProfile/PaymentInfo/Index";
import VendorHistory from "../../components/VendorProfile/VendorHistory/Index";
// import WholesalerHistory from "../../components/WholesalerProfile/WholesalerHistory/index";
import InvoiceHistory from "../../components/VendorProfile/InvoiceHistory/Index";
import MostPurchaseProducts from "../../components/VendorProfile/MosPurchaseProducts/Index.jsx";

const ExporterProfile = (props) => {
  const {
    dueCollectionData,
    activeTab,
    loadingCallback,
    fetchedData,
    invoiceData,
    customerId,
    onSubmitPayment,
  } = props;
  return (
    <>
      <div className="flex flex-col xl:flex-row gap-[3%]">
        <div className="w-[100%] xl:w-[300px] mb-[25px] xl:mb-0 bg-[#F8F9FA] rounded-[16px] p-3">
          <PaymentInfo
            activeTab={activeTab}
            loadingCallback={loadingCallback}
            fetchedData={fetchedData}
            invoiceData={invoiceData}
            onSubmitPayment={onSubmitPayment}
            dueCollectionData={dueCollectionData}
            setSuccessFlashMessage={props.setSuccessFlashMessage}
            setErrorFlashMessage={props.setErrorFlashMessage}
            setWarningMessage={props.setWarningMessage}
            handlePrintPdf={props.handlePrintPdf}
            getDateWiseDueReport={props.getDateWiseDueReport}
            setReportBtn={props.setReportBtn}
            reportBtn={props.reportBtn}
            setFromDate={props.setFromDate}
            setToDate={props.setToDate}
            fromDate={props.fromDate}
            toDate={props.toDate}
            paymentList={props.paymentList}
            paymentAccountList={props.paymentAccountList}
            type="exporter"
          />
        </div>
        <div className="flex-1">
          <VendorHistory
            activeTab={activeTab}
            loadingCallback={loadingCallback}
            fetchedData={fetchedData}
            type="exporter"
          />

          <MostPurchaseProducts
            activeTab={activeTab}
            loadingCallback={loadingCallback}
            fetchedData={fetchedData}
            vendorId={customerId}
            type="exporter"
          />

          <InvoiceHistory
            activeTab={activeTab}
            loadingCallback={loadingCallback}
            invoiceData={invoiceData}
            vendorId={customerId}
            type="exporter"
          />
        </div>
      </div>
    </>
  );
};

export default ExporterProfile;
